(function () {

    var headerHeight = 0;
    var activeId = "";

    function calcHeaderHeight() {
        if (!$(".header__title").is(":visible")) {
            headerHeight = $(".header").outerHeight(true);
        } else {
            headerHeight = $(".header__top").outerHeight(true) +
                $(".header__title").outerHeight(true);
        }
    }

    function scrollActiveLink() {

        calcHeaderHeight();

        var scrollPos = $(window).scrollTop();
        var $header = $(".header");

        $header.find("#nav-main a[href^='#']").each(function () {
            var $link = $(this);
            var target = $link.attr('href');
            var $target = $(target);
            var offsetTop = $header.outerHeight(true) + 20;


            if ($target.length && $target.offset().top - offsetTop <= scrollPos + headerHeight) {
                $header.find("#nav-main a").removeClass('is-active');
                $link.addClass('is-active');
            }
        });
    }

    function scrollDetect() {
        var scrollPos = $(window).scrollTop();

        if (scrollPos > 0) {
            $(".header").addClass("is-scrolled");
        } else {
            $(".header").removeClass("is-scrolled");
        }
    }

    $(window).on("scroll", function () {
        scrollActiveLink();
        scrollDetect();
    });

})();